// DoctorFormModal.tsx
import React from 'react';
import { X } from 'lucide-react';
import { FirmFormProps } from '../common/types';
import FirmForm from './FirmForm';

interface FirmFormModalProps extends FirmFormProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  title: string;
  submitButtonText?: string;
}

const FirmFormModal: React.FC<FirmFormModalProps> = ({
  isOpen,
  onOpenChange,
  firm,
  onSubmit,
  onCancel,
  title,
  submitButtonText = 'Save Firm'
}) => {
  if (!isOpen) return null;

  const handleCancel = () => {
    if (onCancel) onCancel();
    onOpenChange(false);
  };

  const handleSubmit = (formData: any) => {
    onSubmit(formData);
    onOpenChange(false);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200"
        onClick={() => onOpenChange(false)}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <div className="relative bg-white rounded-lg shadow-xl w-full max-w-4xl">
            {/* Modal Header */}
            <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
              <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
              <button
                onClick={() => onOpenChange(false)}
                className="rounded-full p-1.5 hover:bg-gray-100 transition-colors"
                aria-label="Close modal"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6">
              <FirmForm
                firm={firm}
                onSubmit={handleSubmit}
                onCancel={handleCancel}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FirmFormModal;